import { useAuthStore } from "@/stores/auth-store";
import { ADMIN_UPLOAD_ARTICLE_IMAGE } from "@/lib/graphql/mutations/upload";

const GRAPHQL_ENDPOINT =
  import.meta.env.VITE_GRAPHQL_ENDPOINT || "http://127.0.0.1:8080/graphql";

interface UploadArticleImageResult {
  success: boolean;
  url?: string;
  message?: string;
}

export async function uploadArticleImage(
  file: File,
  category = "post-thumbnail"
): Promise<UploadArticleImageResult> {
  const accessToken = useAuthStore.getState().getAccessToken();

  const operations = JSON.stringify({
    query: ADMIN_UPLOAD_ARTICLE_IMAGE,
    variables: {
      input: {
        file: null,
        category,
      },
    },
  });

  const map = JSON.stringify({
    "0": ["variables.input.file"],
  });

  const formData = new FormData();
  formData.append("operations", operations);
  formData.append("map", map);
  formData.append("0", file, file.name);

  const headers: Record<string, string> = {};
  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`;
  }

  const response = await fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers,
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Upload failed: ${response.statusText}`);
  }

  const json = await response.json();

  if (json.errors?.length) {
    throw new Error(json.errors[0].message);
  }

  return json.data.adminUploadArticleImage;
}
